module.exports = __webpack_public_path__ + "fonts/61b9f06900a582ec2e9eb04dce1c0b44.txt";